import { Components, Theme } from '@mui/material/styles';

export const flowPopover: Components<Theme>['MuiPopover'] = {
  styleOverrides: {
    paper: {
      maxHeight: '240px',
      overflow: 'auto',
    },
  },
};
